import Modal from 'react-bootstrap/Modal'
import { Form, Formik } from "formik";
import { TextField } from "../../components/common/TextField/TextField";
import React, { useEffect, useState } from "react";
import { OptionList } from "../../components/common/OptionList/OptionList";
import { Col, Row } from "react-bootstrap";
import ShowNotification from "../../components/common/Notification/ShowNotification";

const EditDataModal = ({ show, setIsEditUser, deleteUserTh, users, updateUserTh, changeUserPasswordTh, userId, ...props }) => {
    let user = users?.find((item) => item.id === parseInt(userId)) || {};

    let [showModal, setShowModal] = useState(show);
    let [showDeleteModal, setShowDeleteModal] = useState(false);
    let [showPasswordModal, setShowPasswordModal] = useState(false);
    let [submitClicked, setSubmitClicked] = useState(false);
    let [role, setRole] = useState(user.role || "user");

    const handleClose = () => {
        setIsEditUser(false);
    };

    useEffect(() => {
        if (show) setShowModal(true);
        else setShowModal(false);
    }, [show]);

    useEffect(() => {
        if (user && user.role) setRole(user.role);
    }, [userId, users]);

    let roleList = [
        { id: 'user', name: 'User', status: 1 },
        { id: 'admin', name: 'Admin', status: 1 }
    ];

    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                id: user.id || '',
                name: user.name || '',
                email: user.email || '',
                role: user.role || 'user',
            }}
            onSubmit={(formValues) => {
                if (!submitClicked) return;

                const userInstance = {
                    name: formValues.name,
                    email: formValues.email,
                    role: role,
                };

                updateUserTh(user.id, userInstance);
                setIsEditUser(false);
            }}
        >
            {() => (
                <>
                    {/* Silmə təsdiqi */}
                    <Modal size="sm" show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Silinməni təsdiq edin</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center">
                            Bu istifadəçini silmək istədiyinizdən əminsiniz?
                        </Modal.Body>
                        <Modal.Footer className="justify-content-center">
                            <button type="button"
                                    className="btn btn-danger mr-2"
                                    onClick={() => {
                                        deleteUserTh(user.id);
                                        setShowDeleteModal(false);
                                        setIsEditUser(false);
                                    }}>Sil</button>
                            <button type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowDeleteModal(false)}>Geri qayıt</button>
                        </Modal.Footer>
                    </Modal>

                    {/* Şifrə dəyişmə */}
                    <Modal size="sm" show={showPasswordModal} onHide={() => setShowPasswordModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Şifrəni dəyiş</Modal.Title>
                        </Modal.Header>
                        <Formik
                            initialValues={{ password: "", password_confirmation: "" }}
                            onSubmit={(values) => {
                                if (values.password !== values.password_confirmation) {
                                    ShowNotification("Xəta", "Şifrələr uyğun deyil", "danger");
                                    return;
                                }
                                if (values.password.length < 8) {
                                    ShowNotification("Xəta", "Şifrə ən azı 8 simvol olmalıdır", "danger");
                                    return;
                                }
                                changeUserPasswordTh(user.id, values.password, values.password_confirmation);
                                setShowPasswordModal(false);
                            }}
                        >
                            {() => (
                                <Form>
                                    <Modal.Body>
                                        <TextField label="Yeni şifrə" name="password" type="password" enableLabel='true' />
                                        <TextField label="Şifrə təkrarı" name="password_confirmation" type="password" enableLabel='true' />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button type="button"
                                                className="btn btn-secondary"
                                                onClick={() => setShowPasswordModal(false)}>Bağla</button>
                                        <button type="submit"
                                                className="btn btn-primary">Dəyiş</button>
                                    </Modal.Footer>
                                </Form>
                            )}
                        </Formik>
                    </Modal>

                    {/* Əsas edit modalı */}
                    <Modal size="md" show={showModal && !showDeleteModal && !showPasswordModal} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>İstifadəçi redaktə et</Modal.Title>
                        </Modal.Header>
                        <Form>
                            <Modal.Body>
                                <TextField label="Ad" name="name" type="text" enableLabel='true' />
                                <TextField label="Email" name="email" type="email" enableLabel='true' />
                                <Row>
                                    <Col>
                                        <OptionList
                                            label="Rol"
                                            data={roleList}
                                            name='role'
                                            selectedItem={role}
                                            setData={setRole}
                                        />
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <button type="button"
                                        className="btn btn-danger mr-auto"
                                        onClick={() => setShowDeleteModal(true)}>Sil</button>
                                <button type="button"
                                        className="btn btn-warning mr-2"
                                        onClick={() => setShowPasswordModal(true)}>Şifrəni dəyiş</button>
                                <button type="submit"
                                        onClick={() => setSubmitClicked(true)}
                                        className="btn btn-primary">Yadda saxla</button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                </>
            )}
        </Formik>
    );
};

export default EditDataModal;
